export const FAVORITE_ICON = `
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="10" fill="none">
    <path fill="#FF1F34" d="M0 3.006C0 6.973 5.5 10 5.5 10S11 6.973 11 3.006C11 1.346 9.618 0 7.912 0 6.936 0 6.066.441 5.5 1.13A3.114 3.114 0 003.088 0C1.382 0 0 1.346 0 3.006z"/>
  </svg>
`;

export const OLD_ONLINE_BOOKING_ICON = `
  <svg width="12" height="12" viewBox="0 0 16 16" fill="#0468FF" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M11 0H13V2H13.4C13.9601 2 14.2401 2 14.454 2.10899C14.6422 2.20487 14.7951 2.35785 14.891 2.54601C15 2.75992 15 3.03995 15 3.6V6H13V4.66667H3V13H7V15H2.6C2.03995 15 1.75992 15 1.54601 14.891C1.35785 14.7951 1.20487 14.6422 1.10899 14.454C1 14.2401 1 13.9601 1 13.4V3.6C1 3.03995 1 2.75992 1.10899 2.54601C1.20487 2.35785 1.35785 2.20487 1.54601 2.10899C1.75992 2 2.03995 2 2.6 2H3V0H5V2H11V0ZM8.30285 11.1761L10.2611 6.35797L14.6015 8.12185L10.9817 10.8652L13.1317 11.7389L7.87009 15.5007L9.43978 11.6382L8.30285 11.1761Z" />
  </svg>
`;

export const DISCOUNT_ICON = `
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12ZM7.875 6.75C8.49632 6.75 9 7.25368 9 7.875C9 8.49632 8.49632 9 7.875 9C7.25368 9 6.75 8.49632 6.75 7.875C6.75 7.25368 7.25368 6.75 7.875 6.75ZM5.25 4.125C5.25 3.50368 4.74632 3 4.125 3C3.50368 3 3 3.50368 3 4.125C3 4.74632 3.50368 5.25 4.125 5.25C4.74632 5.25 5.25 4.74632 5.25 4.125ZM8.99995 3H7.49018L3 9H4.50977L8.99995 3Z" fill="#2AA200"/>
  </svg>
`;

// Шевроны пагинации мультипина — path из @cian/ui-kit-design-tokens (ActionChevronLeftSmall / RightSmall, 16px),
// цвет наследуется от кнопки через currentColor
export const CHEVRON_LEFT_SMALL_ICON = `
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16">
    <path fill="currentColor" fill-rule="evenodd" clip-rule="evenodd" d="m9.646 12.707 1.414-1.414L7.768 8l3.292-3.293-1.414-1.414L4.94 8z"/>
  </svg>
`;

export const CHEVRON_RIGHT_SMALL_ICON = `
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16">
    <path fill="currentColor" fill-rule="evenodd" clip-rule="evenodd" d="m6.354 12.707-1.415-1.414L8.232 8 4.94 4.707l1.415-1.414L11.06 8z"/>
  </svg>
`;
